import { ElementType, useElementIndex } from '../../contexts/elementIndex';

export const useCurrentRequirementIndex = () => useElementIndex(ElementType.Requirement);
